import { h } from 'preact'
import Icon, { IconType } from '../../../preact-components/assets'

const IconCell = (accessor: string, icon: IconType) =>
  (props: any) => <div className='overview__table-icon'>
    {props[accessor]}
    <Icon icon={icon} width={12} height={12} />
  </div>

export default IconCell
